export default "__VITE_ASSET__B3j6IuMT__"